export const isEmailAddress = (value?: string | null): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value?.trim() ?? "");

export const normalizePaymentPhone = (value?: string | null): string => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed || isEmailAddress(trimmed)) return "";

  const digits = trimmed.replace(/\D/g, "");
  if (digits.length === 10) return digits;
  if (digits.length >= 11 && digits.length <= 15) return `+${digits}`;
  return "";
};

export const paymentContactFromIdentifier = (
  identifier?: string | null,
  phoneOverride?: string | null
) => ({
  email: isEmailAddress(identifier) ? identifier!.trim().toLowerCase() : "",
  phone: normalizePaymentPhone(phoneOverride) || normalizePaymentPhone(identifier),
});

export const requiresPaymentPhone = (identifier?: string | null): boolean =>
  !normalizePaymentPhone(identifier);

